import styled, { css } from "styled-components";

export const PageCountWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    cursor: pointer;

    color: ${theme?.colour?.secondary ?? "#04333B"};
    ${p => p.selected && css`
      color: ${theme?.colour?.primary ?? "#1DBD6B"};
    `}
  `}
`;